import { getPathVariables } from '../../misc';

const getFormattedPricing = pricing => {
  const locale = getPathVariables(window.location.pathname)[0];
  const formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'USD'
  });

  return formatter.format(pricing).replace('US', '');
};

export default getFormattedPricing;
